import { useDispatch, useSelector } from 'react-redux';

export const useUpdatePostDispatch = () => useDispatch();
export const useUpdatePostSelector = useSelector;

export const useUpdateButtonDispatch = () => useDispatch();
